import React from 'react'
import Navbar from './components/Navbar/Navbar'
import Footer from './components/Footer/Footer'
import Routing from "./route/Routing"

const App = () => {
  return (
    <div>
      <Navbar />
      <Routing/>
      <Footer />
    </div>
  )
}

export default App